import basicRest from '../common/CommonRestFunctions'

const baseCompanyUrl = '/company'
const baseResposibleTypeUrl = '/resposibleType'

export default {
  getCompanies () {
    return basicRest.executeBasicAxiosGet(baseCompanyUrl + '/list')
  },
  getBaseCompanies () {
    return basicRest.executeBasicAxiosGet(baseCompanyUrl + '/base-list')
  },
  getBasicCompaniesInfo () {
    return basicRest.executeBasicAxiosGet(baseCompanyUrl + '/base-list')
  },
  getResposibleType () {
    return basicRest.executeBasicAxiosGet(baseResposibleTypeUrl + '/list')
  },
  saveCompany (companyInfo) {
    return basicRest.executeBasicAxiosPost(baseCompanyUrl + '/save', companyInfo)
  },
  removeCompany (id) {
    return basicRest.executeBasicAxiosRemove(baseCompanyUrl + '/remove/' + id)
  }
}
